import type { State } from '../../reducers/types.tsx';
import { getCurrentQueue } from '../ui/index.tsx';

export const isQueueFavorited = (state: State): boolean => {
	const queue = getCurrentQueue(state);
	return queue ? queue.isFavorite : false;
};
